import { DataGridLayout, List } from 'framework/list';
import { ShowSection, ShowPageLayout } from 'framework/ui/layout';
import StructureCreatedListLinkField from './StructureCreatedListLinkField';
import { Typography } from '@mui/material';
import ViewQualificationStructureBreadcrumbs from '../breadcrumbs/QualificationStructureBreadcrumbs';
import StructureBadgeField from './StructureBadgeField';
import useQualificationStructureService from '../services/qualificationStructureService';

const QualificationStructureList = () => {
  const { search } = useQualificationStructureService();

  return (
    <ShowPageLayout breadcrumbs={<ViewQualificationStructureBreadcrumbs />}>
      <Typography variant="h1" m={3} color="brand">
        Target Versions
      </Typography>
      <List getDataMethod={search} defaultSortOrder="DESC" defaultSortField="createdAt">
        <ShowSection sx={{ m: 3, pt: 2 }}>
          <DataGridLayout>
            <StructureCreatedListLinkField label="Created at" createdAt="createdAt" width="50%" id="id" />
            <StructureBadgeField />
          </DataGridLayout>
        </ShowSection>
      </List>
    </ShowPageLayout>
  );
};
export default QualificationStructureList;
